export const CLIENTS = {
  settings: {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  },

  logo: [
    {
      row: ['logo-1', 'logo-2', 'logo-3', 'logo-4', 'logo-5', 'logo-6', 'logo-7', 'logo-8', 'logo-9', 'logo-10', 'logo-11', 'logo-12', 'logo-13', 'logo-14', 'logo-15', 'logo-16', 'logo-17', 'logo-18',]
    },

    {
      row: ['logo-19', 'logo-20', 'logo-21', 'logo-22', 'logo-23', 'logo-24', 'logo-25', 'logo-26', 'logo-27', 'logo-28', 'logo-29', 'logo-30', 'logo-31', 'logo-32', 'logo-33', 'logo-34', 'logo-35', 'logo-36']
    },
  ]
}

export const PROJECT = {
  settings: {
    ...CLIENTS.settings
  },

  gallery: ['bg-home-slider-1', 'bg-home-slider-2', 'bg-home-slider-3', 'bg-home-slider-4', 'bg-home-slider-5', 'bg-home-slider-6']
}